// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";
import { getStorage } from "firebase/storage";
import { getFunctions } from 'firebase/functions';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDmNqpyl3JYak4HtPEcz5RsRVoV6eZIubM",
    authDomain: "flowframe-dc5ab.firebaseapp.com",
    projectId: "flowframe-dc5ab",
    storageBucket: "flowframe-dc5ab.firebasestorage.app",
    messagingSenderId: "199237620172",
    appId: "1:199237620172:web:918007d1824a84baf98d69",
    measurementId: "G-E7RSTJ9G15"
  };

  // Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});
export const auth = getAuth(app);
export const messaging = getMessaging(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
// export { app };

// Dev-only: expose auth on window so we can grab an ID token from the browser
// console when smoke-testing Cloud Functions / private Cloud Run endpoints.
// Webpack tree-shakes this out of production builds via NODE_ENV check.
if (typeof window !== "undefined" && process.env.NODE_ENV !== "production") {
  window.__flowframeAuth = auth;
}